import { GeneralService } from './../../services/admin/general.service';
import { EMService } from './../../services/invoices-em/em.service';
import { Component, OnInit, ViewChild, TemplateRef, Input } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { CatalogsService } from './../../services/catalogs/catalogs.service';
import { ToasterService, ToasterConfig } from 'angular5-toaster';
import { StorageService } from '../../services/storage.service';
import { User } from '../../models/user';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { distinctUntilChanged, debounceTime, switchMap, tap, catchError } from 'rxjs/operators';
import { concat } from 'rxjs/observable/concat';
import { of } from 'rxjs/observable/of';
import 'rxjs/add/operator/map';
import {TranslateService} from '@ngx-translate/core';
import { Router, ActivatedRoute, Params, Data} from '@angular/router';
import { HomeComponent } from '../../pages/home/home.component'


@Component({
  selector: 'app-invoicesemMassive',
  templateUrl: './invoicesem-massive.component.html',
  styleUrls: ['./invoicesem-massive.component.scss'],
  providers: [GeneralService, CatalogsService, EMService]
})
export class EMMassiveComponent implements OnInit {

public user: User;
public rol;
public toasterconfig: ToasterConfig =
new ToasterConfig({timeout: 500});

  constructor(
    private translate: TranslateService,
    private general: GeneralService,
    private storageService: StorageService,
    public catalogs: CatalogsService,
    private emService: EMService,
    private modalService: NgbModal,
    private toasterService: ToasterService,
    private route: ActivatedRoute,
    private HomeComponent: HomeComponent
  ) {

    

  }

  ngOnInit() {
    this.noBack();
    this.user = this.storageService.getCurrentUser();
    this.rol = this.user.rol.id;
    
  }

  noBack() {
    history.pushState(null, null, location.href);
      window.onpopstate = function () {
          history.go(1);
      };
  }

  

}



// WEBPACK FOOTER //
// ./src/app/pages/invoices-em-massive/invoicesem-massive.component.ts